export default {
    common: {
        actions: "Գործողություն",
        view: "Պատկեր",
        edit: "Խմբագրել",
        delete: "Ջնջել",
        manage: "Կառավարել",
        preview: "Նախադիտում",
        clear: "Մաքրել",
        confirm: "Հաստատել",
        submit: "Ուղարկել",
        next: "Հաջորդ",
        back: "Հետ",
        save: "Պահպանել",
        reset: "Վերականգնել",
        cancel: "Չեղարկել",
        find: "Գտնել",
        refresh: "Թարմացնել",
        resend_email: "Կրկին ուղարկել E-mail",
        upload: "Վերբեռնել",
        add: "Ավելացնել",
        prompt: "Հուշել",
        ok: "Լավ",
        continue: "Շարունակել",
        update: "Թարմացնել",
        apply: "Կիրառել",
        previous: "Նախորդ",
        type: "Տեսակ",
        success: "Հաջողություն",
        fail: "Ձախողում",
        no_data: "Չկա տվյալ",
        start_time: "Սկսման ժամանակ",
        end_time: "Ավարտի ժամանակ",
        per_page: "Գրառումների քանակը մեկ էջում",
        yes: "Այո",
        start_date: "Սկսման ժամանակ",
        end_date: "Ավարտի ժամանակ",
        login: "Մուտքանուն",
        password: "Գաղտնաբառ",
        email: "Email",
        welcome: "Բարի գալուստ",
        search: "Որոնել",
        enter: "Մուտքագրել",
        pending: "Սպասման մեջ",
        created: "Ստեղծել",
        in_query: "Հարցման մեջ",

        Blue: "Կապույտ",
        Green: "Կանաչ",
        Red: "Կարմիր",
        Yellow: "Դեղին",
        White: "Սպիտակ",
        Pink: "Վարդագույն",
        Cyan: "Երնկնագույն",

        device_deleted: "Սարքը ջնջվել է",
        set_password: "Սահմանել գաղտնաբառ",
        new_password: "Նոր գաղտնաբառ",
        confirm_password: "Հաստատել գաղտնաբառը",
        common_mismatched: "Գաղտնաբառը չի համընկնում",


        query_center: "",
        no_options: "Տարբերակ չկա",
        system_default: "Համակարգ լռելյայն",
        personal_template: "Անձնական ձևանմուշ",
        otaUpdata: "OTA թարմացում",
        is: "Այո",
        is_not: "Ոչ",
        advGroup: "Էկրանի ADV խումբ",
        light_setting: "Լուսավորման կարգավորումներ",
        turn_off: "Անջատել",
        device_advgroup: "Դարպասի գովազդային խումբ",

        common_form_get_code_surplus: " Վրկ․ հետո ուղարկել",
        common_form_get_code: "Կրկին ուղարկել",
        column_manager: "Սյունակների կառավարում",
        common_password_enter: "Խնդրում ենք մուտքարել նոր գաղտնաբառը",
        common_confirm_password_enter: "Խնդրում եմ հաստատել նոր գաղտնաբառը",
        account_remote_login: "Հաշիվը մուտք է գործվել այլ վայրից, խնդրում ենք նորից մուտք գործել:",
    },

    dictionary: {
        vertical: "Ուղղահայաց",
        horizontal: "Հորիզոնական",
        generaluse: "Ընդհանուր օգտագործում",
        discount: "Զեղչ",
        byunit: "Միավորով",
        by_value: "Արժեքով",
        promotion: "Հատուկ առաջարկ",
    },

    month: {
        january: "Հունվար",
        february: "Փետրվար",
        march: "Մարտ",
        April: "Ապրիլ",
        May: "Մայիս",
        June: "Հունիս",
        July: "Հուլիս",
        August: "Օգոստոս",
        September: "Սեպտեմբեր",
        October: "Հոկտեմբեր",
        November: "Նոյեմբեր",
        December: "Դեկտեմբեր",
    },

    zoontime: {
        International: "(GMT-12:00) Միջազգային ամսաթվի գիծ (արևմտյան)",
        Coordinated: "(UTC-11) Համակարգված համընդհանուր ժամանակ -11",
        Hawaii: "(UTC-10) Հավայան կղզիներ",
        Alaska: "(UTC-9) Ալյասկա",
        California: "(UTC-8) Խաղաղօվկիանոսյան ժամանակ (ԱՄՆ և Կանադա) Բախա Կալիֆոռնիա",
        Arizona: "(UTC-7) Լա Պաս, լեռնային ժամանակ (ԱՄՆ և Կանադա), Արիզոնա",
        America: "(UTC-6) Սասկաչևան, կենտրոնական ժամանակ, Կենտրոնական Ամերիկա",
        Eastern: "(UTC-5) Բոգոտա, Լիմա, Կիտո, Ռիո Բրանկո, արևելյան ժամանակ, Ինդիանա (արևելք)",
        Caracas: "(UTC-4:30) Կարակաս",
        Atlantic: "(UTC-4) Ատլանտյան ժամանակ, Կուիաբա, Ջորջթաուն, Լա Պաս, Սանտյագո",
        Newfoundland: "(UTC-3:30) Նյուֆաունդլենդ",
        Brasilia: "(UTC-3) Բրազիլիա, Բուենոս Այրես, Գրենլանդիա, Կայեննա",
        International2: "(UTC-2) Միջազգային ամսաթվի գիծ արևմտյան -02",
        Azores: "(UTC-1) Կաբո Վերդե կղզիներ, Ազորյան կղզիներ",
        Edinburgh: "(UTC) Դուբլին, Էդինբուրգ, Լիսաբոն, Լոնդոն, Միջազգային ամսաթվի գիծ (արևմտյան)",
        Brussels: "(UTC+1) Ամստերդամ, Բրյուսել, Սարաևո",
        Damascus: "(UTC+2) Բեյրութ, Դամասկոս, Արևելյան Եվրոպա, Կահիրե, Աթենք, Երուսաղեմ",
        Kuwait: "(UTC+3) Բաղդադ, Քուվեյթ, Մոսկվա, Սանկտ Պետերբուրգ, Նայրոբի",
        Tehran: "(UTC+3:30) Թեհրան",
        Yerevan: "(UTC+4) Աբու Դաբի, Երևան, Բաքու, Պորտ Լուի, Սամառա",
        Kabul: "(UTC+4:30) Քաբուլ",
        Karachi: "(UTC+5) Աշխաբադ, Իսլամաբադ, Կարաչի",
        Calcutta: "(UTC+5:30) Չեննայ, Կալկաթա Մումբայ, Նյու Դելի",
        Kathmandu: "(UTC+5:45) Կատմանդու",
        Novosibirsk: "(UTC+6) Աստանա, Դաքքա, Նովոսիբիրսկ",
        Yangon: "(UTC+6:30) Յանգոն",
        Jakarta: "(UTC+7) Բանգկոկ, Հանոյ, Ջակարտա",
        Beijing: "(UTC+08:00) Պեկին, Չունցին, Հոնկոնգ, Ուրումչի, Կուալա Լումպուր, Սինգապուր",
        Yakutsk: "(UTC+9) Օսակա, Տոկիո, Սեուլ, Յակուտսկ",
        Adelaide: "(UTC+9:30) Ադելաիդա, Դարվին",
        Canberra: "(UTC+10) Բրիսբեն, Վլադիվոստոկ, Գուամ, Կանբերրա",
        Islands: "(UTC+11) Սողոմոնյան կղզիներ, Նոր Կալեդոնիա",
        Oakland: "(UTC+12) Անադիր, Օքլենդ, Վելինգտոն, Ֆիջի",
        alofa: "(UTC+13) Նուկուալոֆա, Սամոայի կղզիներ",
        Island: "(UTC+14) Քրիսմաս կղզի",
    },
};
